(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/navigation-tabs.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/navigation-tabs.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$tickets$next$com = svs.tickets.next.components.nova,
  TabLinks = _svs$tickets$next$com.TabLinks,
  TabLink = _svs$tickets$next$com.TabLink;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const getCampaignTicket = svs.tickets.next.utils.utils.getCampaignTicket;
const TAB_PATHS = {
  lobby: '/lobby',
  more: '/mer'
};
const getCampaignPaths = () => {
  const ticketInfo = getCampaignTicket();
  const paths = [];
  if (!ticketInfo) {
    return paths;
  }
  if (ticketInfo.alternativeUrl) {
    paths.push("/valja/".concat(ticketInfo.alternativeUrl));
  }
  paths.push("/valja/".concat(ticketInfo.type));
  return paths;
};
const getInitialTab = pathname => {
  if (getCampaignPaths().includes(pathname)) {
    return 'hero';
  }
  if (pathname === '/mer') {
    return 'more';
  }
  return 'lobby';
};
const NavigationTabs = _ref => {
  var _svs$tickets$data$mod;
  let history = _ref.history,
    location = _ref.location,
    onTabChange = _ref.onTabChange;
  const _useState = useState(() => getInitialTab(location.pathname)),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const campaignTicket = getCampaignTicket();
  const hasCampaignTicket = Boolean(getCampaignTicket());
  const lobbyTabNames = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.lobbyTabNames) || {};
  useEffect(() => {
    setActiveTab(getInitialTab(location.pathname));
  }, [location.pathname]);
  const handleTabChange = tab => {
    if (tab === activeTab) {
      return;
    }
    setActiveTab(tab);
    if (tab === 'hero' && hasCampaignTicket) {
      const campaignPaths = getCampaignPaths();
      if (campaignPaths.length > 0) {
        history.push(campaignPaths[0]);
        return;
      }
    }
    history.push(TAB_PATHS[tab]);
    onTabChange === null || onTabChange === void 0 || onTabChange(tab);
  };
  return React.createElement("div", {
    className: "padding-v-2 u-position-relative tickets-navigation-index"
  }, React.createElement("div", {
    className: "tickets-next-grid-lock w100 padding-h-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    am: {
      gutter: 0
    },
    lg: {
      gutter: 0
    },
    md: {
      gutter: 0
    },
    sm: {
      gutter: 0
    },
    xl: {
      gutter: 0
    },
    xs: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    am: {
      col: 8,
      offset: 2
    },
    lg: {
      col: 4,
      offset: 4
    },
    md: {
      col: 6,
      offset: 3
    },
    sm: {
      col: 10,
      offset: 1
    },
    xl: {
      col: 4,
      offset: 4
    },
    xs: {
      col: 12,
      offset: 0
    }
  }, React.createElement(TabLinks, {
    stretchItems: true
  }, hasCampaignTicket && React.createElement(TabLink, {
    isActive: activeTab === 'hero',
    onClick: () => handleTabChange('hero')
  }, lobbyTabNames.campaign || campaignTicket.name), React.createElement(TabLink, {
    isActive: activeTab === 'lobby',
    onClick: () => handleTabChange('lobby')
  }, lobbyTabNames.lobby || 'Alla Triss'), React.createElement(TabLink, {
    isActive: activeTab === 'more',
    onClick: () => handleTabChange('more')
  }, lobbyTabNames.more || 'Mer från Triss')))))));
};
setGlobal('svs.tickets.next.components.NavigationTabs', NavigationTabs);

 })(window);